<div class="container-fluid" id="grad1">
  <div class="row justify-content-center">
    <div class="col-sm-12 col-md-11 col-lg-10 my-4">
      <div class="card pt-4 pb-2 full_height">
        <app-header></app-header>
        <main class="form-card">
          <form action="" [formGroup]="contactForm">
            <h4 class="text-center mt-4">Let us know your interests.</h4>
            <br />
              
            <div class="row">
              <div class="col-lg-12 form-group">
                <label class="col-sm-12 col-md-3 col-lg-3 col-xl-4 label-right pl-0" for="cname">
                  <strong class="required-fileds">* </strong>Company Name:</label>
                <input
                  type="text"
                  id="cname"
                  class="form-control col-sm-12 col-md-8 col-lg-7 col-xl-5"
                  formControlName="fcCompanyName"
                  required
                  [ngClass]="{
                    'is-invalid': submitted && cf['fcCompanyName'].errors
                  }"
                />
                <div
                  *ngIf="submitted && cf['fcCompanyName'].errors"
                  class="invalid-feedback"
                >
                  <div
                    class="ml-33"
                    *ngIf="cf['fcCompanyName'].errors['required']"
                  >
                    Company Name is required
                  </div>
                </div>
              </div>
              
              <div class="col-lg-12 form-group">
                <label class="col-sm-12 col-md-3 col-lg-3 col-xl-4 label-right pl-0" for="fname"
                  ><strong class="required-fileds">* </strong>First Name:</label
                >
                <input
                  type="text"
                  id="fname"
                  class="form-control col-sm-12 col-md-8 col-lg-7 col-xl-5"
                  formControlName="fcFirstName"
                  required
                  [ngClass]="{
                    'is-invalid': submitted && cf['fcFirstName'].errors
                  }"
                />
                <div
                  *ngIf="submitted && cf['fcFirstName'].errors"
                  class="invalid-feedback"
                >
                  <div class="ml-33" *ngIf="cf['fcFirstName'].errors['required']">
                    First Name is required
                  </div>
                </div>
              </div>

              <div class="col-lg-12 form-group">
                <label class="col-sm-12 col-md-3 col-lg-3 col-xl-4 label-right pl-0" for="lname">
                  <strong class="required-fileds">* </strong>Last Name:</label>
                <input
                  type="text"
                  id="lname"
                  class="form-control col-sm-12 col-md-8 col-lg-7 col-xl-5"
                  formControlName="fcLastName"
                  required
                  [ngClass]="{
                    'is-invalid': submitted && cf['fcLastName'].errors
                  }"
                />
                <div
                  *ngIf="submitted && cf['fcLastName'].errors"
                  class="invalid-feedback"
                >
                  <div class="ml-33" *ngIf="cf['fcLastName'].errors['required']">
                    Last Name is required
                  </div>
                </div>
              </div>

              <div class="col-lg-12 form-group">
                <label class="col-sm-12 col-md-3 col-lg-3 col-xl-4 label-right pl-0" for="email">
                  <strong class="required-fileds">* </strong>Email:</label>
                <input
                  type="text"
                  id="email"
                  class="form-control col-sm-12 col-md-8 col-lg-7 col-xl-5"
                  formControlName="fcEmail"
                  required
                  [ngClass]="{
                    'is-invalid': submitted && cf['fcEmail'].errors
                  }"
                />
                <div
                  *ngIf="submitted && cf['fcEmail'].errors"
                  class="invalid-feedback"
                >
                  <div class="ml-33" *ngIf="cf['fcEmail'].errors['required']">
                    Email is required
                  </div>
                </div>
              </div>

              
              <div class="col-lg-12 form-group">
                <label class="col-sm-12 col-md-3 col-lg-3 col-xl-4 label-right pl-0" style="vertical-align: top;"  for="message">Message:</label>
                <textarea class="form-control col-sm-12 col-md-8 col-lg-7 col-xl-5" id="message" rows="4"></textarea>
              </div>
              <!-- <div class="d-flex justify-content-center mt-3">
                        <re-captcha
                        (resolved)="resolved($event)"
                        siteKey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
                        ></re-captcha>
                    </div> -->
              <div class="mt-3 text-center w-100">
                <button class="next action-button" (click)="submit()">
                  Submit
                </button>
              </div>
            </div>
           
          </form>
        </main>
      </div>
      <app-footer></app-footer>
    </div>
  </div>
</div>
